import LockerJson from './interfaces/LockerJson'

export default class Locker {
  unitNumber: string
  lockerNumber: number
  unitDisplayNumber: string

  constructor(
    unitNumber: string,
    lockerNumber: number,
    unitDisplayNumber: string,
  ) {
    this.unitNumber = unitNumber
    this.lockerNumber = lockerNumber
    this.unitDisplayNumber = unitDisplayNumber
  }

  displayName() {
    if (!this.unitDisplayNumber) {
      return this.lockerNumber
    }

    return this.unitDisplayNumber + '.' + this.lockerNumber
  }

  static fromJson(data: LockerJson) {
    return new this(data.unitNumber, data.lockerNumber, data.displayNumber)
  }

  toJson(): LockerJson {
    return {
      unitNumber: this.unitNumber,
      lockerNumber: this.lockerNumber,
      displayNumber: this.unitDisplayNumber,
    }
  }
}
